import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, enableProdMode, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainModule } from './main/main.module';
import { ConstantsModule } from './main/shared/constants/constants.module';
import { InfomodalComponent } from './main/shared/infomodal/infomodal.component';
import { UtilsSharedModule } from './main/shared/utils/utils/utils.module';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { MapService } from './utils/map.service';
import { UtilsService } from './utils/utils.service';
import { LoginHeatwaveComponent } from './main/authentication/login-heatwave/login-heatwave.component';
import { AuthServiceForInitiliazerService } from './pages/auth/auth-service-for-initiliazer.service';
import { AuthInterceptorService } from './pages/auth/auth-interceptor.service';
import { ApiResponseInterceptor } from './pages/auth/api-response-interceptor.service';
import { ErrorInterceptor } from './pages/auth/error.service';
import { CookieService } from 'ngx-cookie-service';
import { PrivacyComponent } from './privacy/privacy.component';
import { DeleteUserComponent } from './delete-user/delete-user.component';
// import { RainfallActualMapDataComponent } from './main/side-bar/rainfall-actual/rainfall-actual-map-data/rainfall-actual-map-data.component';

enableProdMode();

// export const initPermissions = (authService: AuthServiceForInitiliazerService) => {
//   return (): Promise<any> => {
//     return authService.verifyRequest();
//   }
// }

@NgModule({
  declarations: [
    AppComponent,
    PagenotfoundComponent,
    InfomodalComponent,
    LoginHeatwaveComponent,
    PrivacyComponent,
    DeleteUserComponent,
  ],
  entryComponents: [
    InfomodalComponent,

  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    MainModule,
    NgbModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserModule
  ],
  providers: [UtilsService, MapService, ConstantsModule, UtilsSharedModule, DeviceDetectorService,CookieService,
  // {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: AuthInterceptorService,
  //     multi: true
  //   },
  //   {
  //     provide: APP_INITIALIZER,
  //     useFactory: initPermissions,
  //     deps: [AuthServiceForInitiliazerService],
  //     multi: true
  //   },

  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass : ApiResponseInterceptor,
  //     multi : true
  //   },
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: ErrorInterceptor,
  //     multi: true
  //   },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
